import axios from "axios";
import { put, takeEvery } from "redux-saga/effects";
import {
    regulationTemplatesReceived,
    getRegulationTemplates as getRegulationTemplatesData
} from "../../actions/regulation/regulationTemplates";
import {} from "../../actions/regulation/CreateRegulation/types";
import {
    DeleteRegulationTemplatesAction,
    DELETE_REGULATION_TEMPLATES,
    GetRegulationTemplatesAction,
    GET_REGULATION_TEMPLATES,
    PostRegulationTemplatesAction,
    POST_REGULATION_TEMPLATES,
    RegulationTemplatesReceivedAction
} from "../../actions/regulation/regulationTemplates/types";
import { showError } from "../../components/commonUtilities";
import { GeneratorYieldType } from "../../interfaces/ActionReducer/GetMethod/GetResponse";

function* getRegulationTemplates(
    action: GetRegulationTemplatesAction
): Generator<
    | Promise<RegulationTemplatesReceivedAction["payload"]>
    | GeneratorYieldType<RegulationTemplatesReceivedAction["payload"]>,
    void,
    RegulationTemplatesReceivedAction["payload"]["data"]
> {
    try {
        const json = yield axios
            .get("api/template/", { params: action.payload.params })
            .then((response) => response.data);

        yield put(regulationTemplatesReceived({ data: json }));
    } catch (error) {
        showError(error);
    }
}

export function* getRegulationTemplatesSaga() {
    yield takeEvery(GET_REGULATION_TEMPLATES, getRegulationTemplates);
}

function* postRegulationTemplates(
    action: PostRegulationTemplatesAction
): Generator<
    | Promise<RegulationTemplatesReceivedAction["payload"]>
    | GeneratorYieldType<RegulationTemplatesReceivedAction["payload"]>,
    void,
    RegulationTemplatesReceivedAction["payload"]["data"]
> {
    try {
        const json = yield axios
            .post("api/template/", action.payload.data)
            .then((response) => response.data);

        yield put(regulationTemplatesReceived({ data: json }));
    } catch (error) {
        showError(error);
    }
}

export function* postRegulationTemplatesSaga() {
    yield takeEvery(POST_REGULATION_TEMPLATES, postRegulationTemplates);
}

function* deleteRegulationTemplates(action: DeleteRegulationTemplatesAction) {
    try {
        yield axios.delete(`api/template/${action.payload.id}/`).then((response) => response.data);

        yield put(getRegulationTemplatesData({ params: {} }));
    } catch (error) {
        showError(error);
    }
}

export function* deleteRegulationTemplatesSaga() {
    yield takeEvery(DELETE_REGULATION_TEMPLATES, deleteRegulationTemplates);
}
